// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";
import { useEffect, useState } from "react";


interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  showSearchForm = true // Default a true se non specificato
}) => {

  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  // Transizione syle text wrapper
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timeOut = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timeOut);
  }, [])

  // Rendering Componente
  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;
  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section className="banner">
      <div className="container-fluid">
        <div className={`text-wrapper ${visible? "visible": ""}`}>
          <p className="mb-2 sub-title" dangerouslySetInnerHTML={{ __html: t('homePage.hero.subTitle') as string }} />
          <h1 className="mb-3">{t('homePage.hero.title')}</h1>
          {showSearchForm && <PropertySearchField searchData={{}} />}
        </div>
      </div>
    </section>
  );
};

export default SubHeaderHome;